import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import jwt_decode from 'jwt-decode';
// Components
import LoadingOverlay from 'components/common/LoadingOverlay';
import CustomButton from 'components/common/CustomButton';
import AssignOrderModal from './AssignOrderModal';
import NotDoneModal from './NotDoneModal';
import QualityCheckConfirmModal from 'components/common/QualityCheckConfirmModal';
// Helpers
import { hasPermission, status } from 'constants/Helpers';
// API
import OrdersListService from 'services/OrdersListService';
// Selectors
import { getPermissionsData } from 'store/app/AppSelectors';
// Localstorage
import { getFromLocalStorage } from 'helpers/LocalStorage';

const ChangeStatusBtn = ({
  item,
  initialParams,
  fetchMoreData,
  details,
  fetchFlorists,
  showAllCTA,
  hasSubmittedBefore,
  hasDeviation,
  hideDone,
  preparationTasks,
}) => {
  const [isLoaderOpen, setIsloaderOpen] = useState(false);
  const [isModalOpen, setIsOpenModal] = useState(false);
  const [isQualityCheckModalOpen, setIsQualityCheckModalOpen] = useState(false);
  const [isNotDoneModalOpen, setIsNotDoneModalOpen] = useState(false);
  const [isProductionOfficer, setIsProductionOfficer] = useState(false);
  const permissions = useSelector((state) => getPermissionsData({ state }));
  const deviationEnabled = true;
  const isQualityCheckEnabled = true;
  const location = useLocation();
  const currentPage = location.pathname.slice(1);
  const navigate = useNavigate();

  const fetchData = () => {
    if (details) {
      fetchMoreData(item?.id);
    } else {
      fetchMoreData(initialParams, 1);
      if (fetchFlorists) {
        fetchFlorists();
      }
    }
  };

  const handleChangeStatus = async (item) => {
    setIsloaderOpen(true);
    try {
      if (item?.preparationStatus === 3 || item?.preparationStatus === 7) {
        await OrdersListService.changeOrderPreparationStatus({ Status: 2 }, item?.id);
        setTimeout(() => fetchData(), 1000);
      } else if (item?.preparationStatus === 2) {
        // The backend refuses Done while a task is unfinished - say so before the call.
        if (preparationTasks && !preparationTasks.allFinished) {
          const left = (preparationTasks.totalCount ?? 0) - (preparationTasks.finishedCount ?? 0);
          toast.error(
            `Finish all tasks before marking the order Done${left > 0 ? ` (${left} left)` : ''}.`
          );
          setIsloaderOpen(false);
          return;
        }
        if (
          isQualityCheckEnabled &&
          item?.preparationType === 1 &&
          item?.orderType !== 10 &&
          item?.partnerName !== 'Talabat'
        ) {
          setIsQualityCheckModalOpen(true);
        } else {
          await OrdersListService.changeOrderPreparationStatus({ Status: 0 }, item?.id);
          setTimeout(() => fetchData(), 500);
        }
      } else if (
        !item?.preparationStatus ||
        item?.preparationStatus === 6 ||
        item?.preparationStatus === 1
      ) {
        if (isProductionOfficer) {
          setIsOpenModal(true);
        } else {
          await OrdersListService.assignFloristStatus(
            {
              assigneeId:
                getFromLocalStorage('floristId') ?? jwt_decode(getFromLocalStorage('token'))?.id,
            },
            item?.id
          );
          setTimeout(() => fetchData(), 1000);
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message ?? 'Status change failed!');
      setIsloaderOpen(false);
    }
    setIsloaderOpen(false);
  };

  const isSubmitted = (productId, cartId) => {
    return hasSubmittedBefore?.filter(
      (sb) => sb?.productId === productId && sb?.cartId === cartId
    )?.[0]?.hasSubmittedBefore;
  };

  const isDoneDisable = (s) => {
    console.log('s', s, 'deviation', deviationEnabled, 'current', currentPage);
    if (s === 'Done' && deviationEnabled && ['orders', 'home'].includes(currentPage)) {
      return true;
    } else {
      console.log('hasSubmittedBefore', hasSubmittedBefore, 'hasDeviation', hasDeviation);
      if (hasSubmittedBefore !== null && hasDeviation !== null) {
        let disableBtn = false;
        hasDeviation?.forEach((d) => {
          if (d?.hasDeviation && !isSubmitted(d?.productId, d?.cartId)) {
            disableBtn = true;
          }
        });
        return s === 'Done' && disableBtn;
      } else {
        return false;
      }
    }
  };

  useEffect(() => {
    setIsProductionOfficer(hasPermission(permissions, 'florist_orders', 'head_assign'));
  }, [permissions]);

  return (
    <>
      {isLoaderOpen && <LoadingOverlay />}
      {isQualityCheckModalOpen && (
        <QualityCheckConfirmModal
          handleCancelClick={() => setIsQualityCheckModalOpen(false)}
          handleProceedClick={() => navigate(`/qualitycheck/${item?.id}`)}
          message={'Please proceed to complete Quality Check!'}
          isOpen={isQualityCheckModalOpen}
          setIsOpen={setIsQualityCheckModalOpen}
          cancelBtnName="Cancel"
        />
      )}
      {isModalOpen && (
        <AssignOrderModal
          isModalOpen={isModalOpen}
          setIsOpenModal={setIsOpenModal}
          orderData={item}
          fetchData={fetchData}
        />
      )}
      {isNotDoneModalOpen && (
        <NotDoneModal
          isModalOpen={isNotDoneModalOpen}
          setIsOpenModal={setIsNotDoneModalOpen}
          orderData={item}
          fetchData={fetchData}
        />
      )}
      {showAllCTA ? (
        typeof status[item?.preparationStatus ?? 6] === 'string' ? (
          <CustomButton
            handleClick={() => handleChangeStatus(item)}
            type={`status ${item?.preparationStatus === 0 ? 'success hidden' : 'primary'}`}
            disabled={item?.preparationStatus === 4}
            name={status[item?.preparationStatus ?? 6]}
          />
        ) : Array.isArray(status[item?.preparationStatus ?? 6]) ? (
          status[item?.preparationStatus ?? 6]?.filter((s) => !(hideDone && s === 'Done')).map((s) => {
            return (
              <CustomButton
                handleClick={
                  s === 'Done' ? () => handleChangeStatus(item) : () => setIsNotDoneModalOpen(true)
                }
                type={`status ${s === 'Done' ? 'success' : 'danger'} ${
                  item?.preparationStatus === 0 ? 'hidden' : ''
                }`}
                name={s}
                key={s}
                // Deliberately not gated on reviewStatus: acknowledging the escalation
                // notification is no longer a precondition for Done.
                disabled={isDoneDisable(s)}
              />
            );
          })
        ) : (
          <CustomButton
            handleClick={() => handleChangeStatus(item)}
            type={`status secondary ${item?.preparationStatus === 0 ? 'hidden' : ''}`}
            disabled={!status[item?.preparationStatus ?? 6].enabled}
            name={status[item?.preparationStatus ?? 6].text}
          />
        )
      ) : (
        <CustomButton
          handleClick={() => handleChangeStatus(item)}
          type="status primary"
          disabled={[0, 2, 3, 4, 5, 7, 8].includes(item?.preparationStatus)}
          name={status[1]}
        />
      )}
    </>
  );
};

export default ChangeStatusBtn;
